import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1065MailingAddress = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 1065 Mailing Address: Where to File (2025)"
          description="Find the correct IRS mailing address for Form 1065 based on your partnership’s location and assets. Avoid delays, penalties, and filing mistakes."
          keywords=""
          canonical="resources/business-tax/form-1065-mailing-address/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          Form 1065{' '}
          <span className="highlight-container">
            <span className="highlight">Mailing Address:</span>
          </span>{' '}
          Where to File Your Partnership Return
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          {process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' && (
            <DynamicBreadcrumbs />
          )}
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-1065-mailing-address/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href="https://www.taxzerone.com/"
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Form 1065 Mailing Address at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <data
                        itemProp="position"
                        value="1"
                        style={{ display: 'none' }}
                      />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of the Form 1065 mailing
                          address
                        </strong>{' '}
                        and how the IRS determines the correct address for
                        partnerships filing their return by mail.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <data
                        itemProp="position"
                        value="2"
                        style={{ display: 'none' }}
                      />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore when partnerships can file Form 1065 by mail,
                        </strong>{' '}
                        when e-filing is required, and how private delivery
                        service rules apply when submitting paper returns to the
                        IRS.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <data
                        itemProp="position"
                        value="3"
                        style={{ display: 'none' }}
                      />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand important Form 1065 mailing requirements,
                        </strong>{' '}
                        including filing deadlines, extension rules, IRS
                        processing locations, and state-level filing
                        responsibilities.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Knowing the correct{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Form 1065 mailing address
                      </strong>{' '}
                      is a key step in filing a partnership tax return by mail.
                      The IRS has different mailing addresses depending on the
                      location of your partnership’s principal place of business
                      and sometimes on the total of your assets reported at year
                      end. Sending your return to the wrong address can cause
                      processing delays, IRS notices or filing problems.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      This resource page will assist you in finding the correct
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        mailing address for IRS Form 1065
                      </strong>{' '}
                      quickly and avoid common mailing mistakes so you can
                      confidently file your partnership return. If you want a
                      faster and easier way to file, you can also{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        e-file Form 1065 online{' '}
                      </strong>{' '}
                      rather than mailing a paper return.
                    </Typography>
                  </Box>
                </Stack>
                <Box
                  component="div"
                  sx={{
                    mb: 5,
                    p: 2,
                    borderRadius: 2,
                  }}
                  className="gradient-bg"
                >
                  <Box sx={{ width: '100%' }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        fontSize: '20px !important',
                      }}
                    >
                      The IRS Encourages E-Filing for Faster, More Secure
                      Processing.
                    </Typography>
                    <Typography variant="body2">
                      E-file Form 1065 now with Taxzerone and easily share
                      schedule k-1s with your shareholders
                    </Typography>
                  </Box>
                  <Box sx={{ width: '100%', textAlign: 'left', mt: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      sx={{
                        textTransform: 'none',
                        boxShadow: 'none',
                        borderRadius: 2,
                        backgroundColor: '#0bf473',
                        color: '#333',
                        fontSize: 18,
                        fontWeight: 600,
                        '&:hover, &:focus, &:active': {
                          backgroundColor: '#fff',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120smail`}
                    >
                      E-file Form 1065
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      mt: 2,
                      backgroundColor: '#fff3b1',
                      py: 1,
                      px: 2,
                      border: '2px dashed #000',
                      color: '#000',
                      lineHeight: 1.3,
                    }}
                  >
                    <b>Grab 10% off</b> your filing fee — just enter{' '}
                    <b style={{ fontSize: 18, color: '#c02121' }}>TZOBIZ10</b>{' '}
                    at checkout.
                  </Box>
                </Box>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#who" sx={{ color: '#0202ff' }}>
                          Who Needs to Know the Form 1065 Mailing Address?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#mail" sx={{ color: '#0202ff' }}>
                          IRS Mailing Addresses for Form 1065
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#using" sx={{ color: '#0202ff' }}>
                          Using a Private Delivery Service (PDS)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#what" sx={{ color: '#0202ff' }}>
                          What Determines Which Address You Use?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#deadline" sx={{ color: '#0202ff' }}>
                          Form 1065 Filing Deadlines
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#shouldyou" sx={{ color: '#0202ff' }}>
                          Should You Mail or E-File Form 1065?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#state" sx={{ color: '#0202ff' }}>
                          State-Level Filing: A Separate Obligation
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mailing Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="who"
                >
                  Who Needs to Know the Form 1065 Mailing Address?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Most partnerships are now required or strongly encouraged to
                  e-file. However, paper filing is still permitted — and
                  sometimes required — in specific situations. You'll need the
                  correct mailing address if:
                </Typography>

                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    Your partnership is{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      not subject to the IRS e-file mandate
                    </span>{' '}
                    (fewer than 10 returns filed of any type during the year)
                  </li>
                  <li>
                    You are filing a{' '}
                    <span style={{ fontWeight: 600 }}>bankruptcy return</span>{' '}
                    (which must be paper filed)
                  </li>
                  <li>
                    You are filing a return with{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      pre-computed penalty and interest
                    </span>{' '}
                    (which must be mailed)
                  </li>
                  <li>
                    You have received an{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      approved hardship waiver
                    </span>{' '}
                    from the IRS e-file requirement
                  </li>
                  <li>
                    You are filing under a{' '}
                    <span style={{ fontWeight: 600 }}>religious exemption</span>{' '}
                    (write "Religious Exemption" at the top of page 1)
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If none of these apply to your partnership, the IRS strongly
                  recommends — and in many cases requires — electronic filing.
                  See the e-filing section below for full details.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="mail"
                >
                  IRS Mailing Addresses for Form 1065 (Current — Last Reviewed
                  February 25, 2025)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  The addresses below are sourced directly from the{' '}
                  <Link
                    href="https://www.irs.gov/filing/where-to-file-your-taxes-for-form-1065"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    IRS "Where to File Your Taxes for Form 1065"
                  </Link>{' '}
                  page. Always verify addresses on IRS.gov before mailing, as
                  the IRS updates these periodically.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Group 1: Partnerships in Eastern and Midwestern States{' '}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                  If your partnership's principal business, office, or agency is
                  located in:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Connecticut, Delaware, District of Columbia, Georgia,
                  Illinois, Indiana, Kentucky, Maine, Maryland, Massachusetts,
                  Michigan, New Hampshire, New Jersey, New York, North Carolina,
                  Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee,
                  Vermont, Virginia, West Virginia, or Wisconsin
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Total Assets at End of Tax Year
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Mailing Address
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Less than $10 million AND Schedule M-3 is NOT
                            filed{' '}
                          </TableCell>

                          <TableCell>
                            {' '}
                            Department of the Treasury Internal Revenue Service
                            Kansas City, MO 64999-0011
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            $10 million or more or less than $10 million and
                            Schedule M-3 is filed
                          </TableCell>

                          <TableCell>
                            {' '}
                            Department of the Treasury Internal Revenue Service
                            Ogden, UT 84201-0011
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Group 2: Partnerships in Western, Southern, and Central States
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                  If your partnership's principal business, office, or agency is
                  located in:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Alabama, Alaska, Arizona, Arkansas, California, Colorado,
                  Florida, Hawaii, Idaho, Iowa, Kansas, Louisiana, Minnesota,
                  Mississippi, Missouri, Montana, Nebraska, Nevada, New Mexico,
                  North Dakota, Oklahoma, Oregon, South Dakota, Texas, Utah,
                  Washington, or Wyoming
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Total Assets at End of Tax Year
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Mailing Address
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Any amount
                          </TableCell>

                          <TableCell>
                            {' '}
                            Department of the Treasury Internal Revenue Service
                            Ogden, UT 84201-0011
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Group 3: Foreign Partnerships and U.S. Possessions
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                  If your partnership is located in a foreign country or U.S.
                  possession:
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Total Assets at End of Tax Year
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Mailing Address
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15, fontWeight: 600 }}>
                            Any amount
                          </TableCell>

                          <TableCell>
                            {' '}
                            Internal Revenue Service P.O. Box 409101 Ogden, UT
                            84409
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="using"
                >
                  Using a Private Delivery Service (PDS)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If you’re mailing Form 1065 through a private delivery service
                  (PDS), keep these rules in mind:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      USPS is the only carrier that can deliver to IRS P.O. Box
                      addresses.
                    </strong>
                  </li>
                  <li>
                    If you use{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      FedEx, UPS, or DHL,
                    </strong>{' '}
                    you must send your return to the IRS’s street address, not a
                    P.O. Box.
                  </li>
                  <li>
                    The IRS treats certain{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      approved private delivery services
                    </strong>{' '}
                    as meeting the{' '}
                    <strong style={{ fontWeight: 600 }}>
                      “timely mailing treated as timely filing”
                    </strong>
                    rule.
                  </li>
                  <li>
                    Private delivery services can provide{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      written proof of the mailing date,
                    </strong>{' '}
                    which can help establish timely filing.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Not all FedEx, UPS, or DHL service types qualify
                    </strong>{' '}
                    under IRS rules, so always verify the current approved list
                    before mailing a time-sensitive return.
                  </li>
                  <li>
                    IRS street addresses for private delivery services are
                    different from USPS mailing addresses, so make sure you use
                    the correct address for your filing method.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="what"
                >
                  What Determines Which Address You Use?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Two factors determine the correct IRS mailing address for Form
                  1065:
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Principal Business Location
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The address is based on where your partnership's principal
                  business, office, or agency is physically located — not where
                  the partnership was formed, where partners live, or where the
                  partnership is registered. A partnership formed in Delaware
                  but operating out of California uses the California (Ogden)
                  address.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Total Assets and Schedule M-3 Status
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For partnerships in the eastern and midwestern states group,
                  the total asset figure from the partnership's balance sheet
                  (Schedule L, Line 14, Column d) is the deciding factor:
                </Typography>

                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Less than $10 million in total assets AND not required to
                      file Schedule M-3  †’
                    </span>{' '}
                    Kansas City{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      $10 million or more in total assets OR required to file
                      Schedule M-3  †’
                    </span>{' '}
                    Ogden{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Partnerships in the western, southern, and central states
                  group always use the Ogden address regardless of asset size.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    What is Schedule M-3?
                  </span>{' '}
                  Schedule M-3 (Net Income (Loss) Reconciliation for Certain
                  Partnerships) is required for partnerships with total assets
                  of $10 million or more at tax year end, or that voluntarily
                  choose to file it. If your partnership files Schedule M-3,
                  always use the Ogden address.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 0.5,

                    lineHeight: 1.5,
                    scrollMarginTop: 83,
                  }}
                  id="deadline"
                >
                  Form 1065 Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Mailing on time is just as important as mailing to the right
                  address.
                </Typography>
                <Box
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: '#f4ffff',
                    mb: 3,
                    border: '1px solid #828282',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontSize: 22, mb: 0.5, fontWeight: 600 }}
                  >
                    March 15
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Need More Time?
                  </Typography>
                  <Typography variant="body1">
                    If you cannot meet the March 15 deadline, you can request an
                    automatic{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      6-month extension
                    </strong>{' '}
                    by filing{' '}
                    <strong style={{ fontWeight: 600 }}> Form 7004</strong>.
                  </Typography>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note :</b>{' '}
                  <i>
                    An extension applies only to the time allowed for filing the
                    return. It does not extend the time required to pay any
                    taxes owed. All tax payments are still due by the original
                    March 15 deadline.
                  </i>
                </Alert>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Filing Type
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Deadline
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Original Form 1065 (2025 tax year)
                          </TableCell>

                          <TableCell>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              March 16, 2026
                            </span>{' '}
                            (March 15 falls on Sunday)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>
                            K-1 distribution to partners
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>
                            March 16, 2026
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Extended return (with Form 7004){' '}
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>
                            September 15, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  For fiscal-year partnerships, the due date is the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    15th day of the 3rd month after the fiscal year ends.
                  </span>{' '}
                  For a complete breakdown of all applicable deadlines,
                  penalties, and extension guidance, see the{' '}
                  <Link
                    href="/resources/business-tax/form-1065-filing-deadlines-and-penalties-guide/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1065 Filing Deadlines and Penalties Guide
                  </Link>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}> Need more time? </span> You
                  can request an automatic 6-month extension by filing{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 7004
                  </Link>{' '}
                  on or before the original due date. No explanation is
                  required, and Form 7004 can itself be e-filed.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="shouldyou"
                >
                  Should You Mail or E-File Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For the vast majority of partnerships,{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    e-filing is the faster, more reliable, and increasingly
                    mandatory
                  </span>{' '}
                  way to submit Form 1065. Here's how the two methods compare:
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Factor
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Paper Mail
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            E-File
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell> Processing time</TableCell>
                          <TableCell>8–12 weeks (or longer)</TableCell>
                          <TableCell>2–3 weeks</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell> Confirmation of receipt</TableCell>
                          <TableCell> None (only mailing proof)</TableCell>
                          <TableCell>Immediate IRS acknowledgment</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell> Error detection</TableCell>
                          <TableCell> After IRS review (weeks later)</TableCell>
                          <TableCell>
                            Built-in validation before submission
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell> K-1 generation</TableCell>
                          <TableCell> Manual</TableCell>
                          <TableCell>Automatic</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell> Risk of address error</TableCell>
                          <TableCell> Yes</TableCell>
                          <TableCell>No</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            Required for 100+ partner partnerships
                          </TableCell>
                          <TableCell> No (e-file mandatory)</TableCell>
                          <TableCell>Yes</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            Required if filing 10+ returns of any type
                          </TableCell>
                          <TableCell>No (e-file mandatory) </TableCell>
                          <TableCell>Yes </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS's e-file mandate now applies to partnerships that file
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    10 or more returns of any type
                  </span>{' '}
                  during the calendar year — including W-2s, 1099s, employment
                  tax returns, and excise tax returns, not just Form 1065
                  itself. Partnerships that cannot meet this requirement may
                  request a hardship waiver by submitting a written request to
                  the Ogden Submission Processing Center (fax: 877-477-0575).
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  TaxZerone makes it easy to{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    e-file Form 1065 online
                  </Link>{' '}
                  with automatic Schedule K-1 generation for all partners,
                  built-in IRS validation, and immediate filing confirmation —
                  all for one flat fee.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="state"
                >
                  State-Level Filing: A Separate Obligation
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Mailing your federal Form 1065 to the IRS satisfies your
                  <span style={{ fontWeight: 600 }}> federal</span> filing
                  obligation only. Most states with an income tax also require
                  partnerships to file a separate{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    state partnership return,
                  </span>{' '}
                  and the mailing address for the state return is entirely
                  different from the IRS address.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If your partnership operates in multiple states, you may have
                  filing obligations in each of those states. Partners who are
                  nonresidents of states where the partnership operates may also
                  have individual nonresident state filing requirements based on
                  the income allocated to them via K-1.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Always check with each applicable state's department of
                  revenue for the correct state mailing address and filing
                  deadlines.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What happens if I mail Form 1065 to the wrong IRS address?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS will generally forward the return to the correct
                  processing center, but this can cause significant delays and
                  may result in the return being treated as late if the
                  forwarding process pushes it past the deadline. Always verify
                  the correct address before mailing.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Can I mail Form 1065 and its K-1s in the same envelope?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. When mailing to the IRS, include all Schedule K-1 copies
                  (one per partner) along with the Form 1065 and all required
                  schedules in a single package. Remember to also send each
                  partner their own individual K-1 copy separately.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Do I need to include a payment when mailing Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  Generally, no. Form 1065 is an informational return and
                  partnerships typically do not owe income tax directly. If a
                  tax payment is required (for example, for BBA audit
                  underpayments), include it with the return and make the check
                  payable to "United States Treasury."
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Is there a filing fee for mailing Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. The IRS does not charge a filing fee for submitting Form
                  1065 by mail.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. My partnership is in a U.S. territory. Where do I mail Form
                  1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Partnerships in U.S. possessions and territories use the
                  foreign address: Internal Revenue Service, P.O. Box 409101,
                  Ogden, UT 84409.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. Can I use FedEx or UPS to mail Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, but you must use the correct{' '}
                  <span style={{ fontWeight: 600 }}> street address</span> for
                  the IRS Submission Processing Center (not the P.O. Box
                  address), and only IRS-designated service types qualify for
                  the timely mailing rule. See the Private Delivery Service
                  section above for the correct addresses.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  7. What if my partnership wants to avoid the complexity of
                  paper filing entirely?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  E-filing through an IRS-authorized provider like TaxZerone is
                  the simplest solution. You can{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    e-file Form 1065 online
                  </Link>{' '}
                  and receive immediate IRS acknowledgment — eliminating address
                  uncertainty, mailing delays, and the risk of lost returns
                  entirely.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready to e-file Form 1065 and skip mailing hassles entirely?
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Get instant IRS acknowledgment, avoid address errors, and ensure
              on-time compliance.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href="/business-tax/efile-irs-form-1065-online/"
              >
                Start E-filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1065MailingAddress;
